import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {editCellInSubmitForm, getRowData} from "../functions";
import {submitDocumentFormAction} from "../../../Store/SubmitDocumentForm";

const SelectTafsiliFormatter = (props) => {

  const sendData = useSelector(s => s.submitDocumentFormReducer)
  const dispatch = useDispatch();


  const selectedRowId = props.cell.getData().uniqId

  let holder = props?.cell?.getData()?.holder;
  holder = JSON.parse(holder ? holder : "{}")
  // const holder = sendData.tableData.filter(v=>v.uniqId===rowId)[0].holder;

  
  return (
    <div className={'w-100'}>
      {
        holder?.hasSubAccount ?
          <>
            <select
              className={'w-100'}
              value={props.cell.getData()[props.myKey]}
              onChange={(e)=>props.handleChange(e,selectedRowId,props.myKey)}
              dir={'rtl'}
            >
              <option value={""} hidden={true}>انتخاب کنید</option>


              {holder.accountTitles.map((row, index) => (
                <option key={index} value={row.value}>{holder.accountCodes[index].label}-{row.label}</option>
              ))}
            </select>
          </> : <>_</>
      }
    </div>
  );
}

export default React.memo(SelectTafsiliFormatter);